/* ==========================================================================
   Localization — country picker, money formatting, free-shipping rules

   Shopify Markets decides the country, currency and prices server-side; the
   picker panel is rendered in Liquid inside Shopify's localization form.
   This file opens/closes the picker, submits the form when a country or
   language is chosen, and formats money for the cart in the active currency.
   ========================================================================== */

window.LUVZ = window.LUVZ || {};

LUVZ.localization = (function () {
  'use strict';

  var shop = LUVZ.shop || {};
  var listeners = [];

  /* ---------- money ------------------------------------------------------ */

  function currencyCode() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || shop.currency || 'EUR';
  }

  function rate() {
    var r = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
    return r && !isNaN(r) ? r : 1;
  }

  function withDelimiters(number, precision, thousands, decimal) {
    var fixed = (number / 100).toFixed(precision);
    var parts = fixed.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }

  /* Shopify's money format, the same one the `money` filter uses, so the
     cart reads exactly like the prices rendered in Liquid ("€26,90"). */
  function formatShop(cents) {
    var format = shop.moneyFormat || '{{amount}}';
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      switch (key) {
        case 'amount': return withDelimiters(cents, 2, ',', '.');
        case 'amount_no_decimals': return withDelimiters(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(cents, 2, '\'', '.');
        case 'amount_with_space_separator': return withDelimiters(cents, 2, ' ', ',');
        default: return withDelimiters(cents, 2, ',', '.');
      }
    });
  }

  /* cents -> formatted string in the active currency */
  function formatMoney(cents, code) {
    code = code || currencyCode();
    cents = Math.round(Number(cents) || 0);
    if (code === shop.shopCurrency) return formatShop(cents);
    try {
      return new Intl.NumberFormat(shop.locale || 'en', { style: 'currency', currency: code }).format(cents / 100);
    } catch (e) {
      return formatShop(cents);
    }
  }

  /* ---------- free shipping --------------------------------------------- */

  /* Same rules as the static site: some countries ship free on every order,
     some carry no free-shipping claim at all, everywhere else unlocks at
     the threshold (set in EUR, converted with the market's rate). */
  function freeShipping() {
    var s = LUVZ.shipping || {};
    var c = shop.country;
    if ((s.noClaim || []).indexOf(c) > -1) return { claim: false };
    if ((s.freeAlways || []).indexOf(c) > -1) return { free: true };
    return { amount: Math.round((s.threshold || 0) * 100 * rate()), currency: currencyCode() };
  }

  /* ---------- picker ----------------------------------------------------- */

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-loc]'), function (loc) {
      var toggle = loc.querySelector('[data-loc-toggle]');
      var panel = loc.querySelector('[data-loc-panel]');
      var form = loc.querySelector('form');
      if (!toggle || !panel) return;

      function close() {
        loc.classList.remove('is-open');
        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      }
      function open() {
        loc.classList.add('is-open');
        panel.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      }

      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        if (loc.classList.contains('is-open')) close(); else open();
      });
      document.addEventListener('click', function (e) {
        if (!loc.contains(e.target)) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });
      panel.addEventListener('click', function (e) {
        if (!form) return;
        var c = e.target.closest('[data-set-country]');
        var l = e.target.closest('[data-set-language]');
        if (c) form.querySelector('[name="country_code"]').value = c.getAttribute('data-set-country');
        if (l) form.querySelector('[name="language_code"]').value = l.getAttribute('data-set-language');
        if (c || l) { close(); form.submit(); }
      });
    });
  }

  function onChange(fn) { listeners.push(fn); }

  return {
    init: init,
    formatMoney: formatMoney,
    currencyCode: currencyCode,
    freeShipping: freeShipping,
    onChange: onChange,
    get country() { return shop.country; },
  };
}());
